import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { ZipCodeSlideType } from "../../../types/zipCodeSlide";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";

interface ZipCodeSlideProps {
  data: ZipCodeSlideType;
  setPayloadValue: any;
  onNavigation: OnNavigationType;
}

const ZipCodeSlide: React.FC<ZipCodeSlideProps> = ({
  data,
  onNavigation,
  setPayloadValue,
}) => {
  const [zipCode, setZipCode] = useState<string>("");

  // useEffect(() => {
  //   if (zipCode.length !== 0) setPayloadValue(`contact[${"zipcode"}]`, zipCode);
  // }, [zipCode]);

  return (
    <div className={styles.zipCodeSlideContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.subTitle}>{data.subtitle}</div>
        <div className={styles.title}>{data.title}</div>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.labels} htmlFor="zipCode">
          {data.label}
        </label>
        <input
          className={styles.inputField}
          type="text"
          value={zipCode}
          onChange={(e) => setZipCode(e.target.value)}
          id="zipCode"
          maxLength={5}
          placeholder={data.placeholder || ""}
        />
      </div>
      {zipCode.length === 5 && (
        <SlideNavigation
          onNavigation={() => onNavigation(1)}
          nextText={"Next"}
          selected={[12]}
        />
      )}
    </div>
  );
};

export default ZipCodeSlide;
